function UserProfile({ user, onRefresh }) {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    return (
        <div className="space-y-3 sm:space-y-4">
            {/* User Profile Card */}
            <div className="bg-gray-50 rounded-xl p-4 sm:p-5 shadow-md">
                <h1 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">👤 الملف الشخصي</h1>

                <div className="space-y-3">
                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                        <span className="font-semibold text-gray-600">معرف المستخدم:</span>
                        <span className="text-gray-900 font-mono">{user.userId}</span>
                    </div>

                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                        <span className="font-semibold text-gray-600">الاسم الأول:</span>
                        <span className="text-gray-900">{user.firstName || 'غير متوفر'}</span>
                    </div>

                    {user.lastName && (
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                            <span className="font-semibold text-gray-600">الاسم الأخير:</span>
                            <span className="text-gray-900">{user.lastName}</span>
                        </div>
                    )}

                    {user.username && (
                        <div className="flex justify-between items-center py-2 border-b border-gray-200">
                            <span className="font-semibold text-gray-600">اسم المستخدم:</span>
                            <span className="text-gray-900">@{user.username}</span>
                        </div>
                    )}

                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                        <span className="font-semibold text-gray-600">الدور:</span>
                        <span className={`role-badge ${user.role}`}>
                            {user.role === 'admin' ? 'مدير' : user.role === 'reporter' ? 'مراسل' : 'مشاهد'}
                        </span>
                    </div>

                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                        <span className="font-semibold text-gray-600">الحالة:</span>
                        <span className={`status-badge ${user.status}`}>
                            {user.status === 'active' ? 'نشط' : user.status === 'suspended' ? 'معلق' : 'محظور'}
                        </span>
                    </div>

                    <div className="flex justify-between items-center py-2">
                        <span className="font-semibold text-gray-600">آخر نشاط:</span>
                        <span className="text-gray-900 text-sm">{formatDate(user.lastActive)}</span>
                    </div>
                </div>
            </div>

            {/* Permissions Card */}
            {user.permissions && (
                <div className="bg-gray-50 rounded-xl p-5 shadow-md">
                    <h2 className="text-lg font-semibold mb-3 text-gray-900">🔐 الصلاحيات</h2>
                    <div className="space-y-2">
                        <div className="flex items-center space-x-2 space-x-reverse py-1">
                            <span className={`text-lg ${user.permissions.canSubmitReports ? 'text-green-500' : 'text-red-500'}`}>
                                {user.permissions.canSubmitReports ? '✓' : '✗'}
                            </span>
                            <span className="text-gray-900">إرسال البلاغات</span>
                        </div>
                        <div className="flex items-center space-x-2 space-x-reverse py-1">
                            <span className={`text-lg ${user.permissions.canViewReports ? 'text-green-500' : 'text-red-500'}`}>
                                {user.permissions.canViewReports ? '✓' : '✗'}
                            </span>
                            <span className="text-gray-900">عرض البلاغات</span>
                        </div>
                        <div className="flex items-center space-x-2 space-x-reverse py-1">
                            <span className={`text-lg ${user.permissions.canManageUsers ? 'text-green-500' : 'text-red-500'}`}>
                                {user.permissions.canManageUsers ? '✓' : '✗'}
                            </span>
                            <span className="text-gray-900">إدارة المستخدمين</span>
                        </div>
                    </div>
                </div>
            )}

            {/* App Information Card */}
            <div className="bg-gray-50 rounded-xl p-5 shadow-md">
                <h2 className="text-lg font-semibold mb-3 text-gray-900">ℹ️ معلومات التطبيق</h2>
                <div className="space-y-3">
                    <div className="flex justify-between items-center py-2 border-b border-gray-200">
                        <span className="font-semibold text-gray-600">التحقق:</span>
                        <span className="text-green-500 font-semibold">✓ تم التحقق</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                        <span className="font-semibold text-gray-600">المصدر:</span>
                        <span className="text-gray-900">تطبيق تيليجرام المصغر</span>
                    </div>
                </div>
            </div>

            {/* Refresh Button */}
            <button className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors" onClick={onRefresh}>
                🔄 تحديث البيانات
            </button>
        </div>
    );
}

export default UserProfile;
